import Experience from "../../Experience/Experience.js"
import "splitting/dist/splitting.css"
import "splitting/dist/splitting-cells.css"
import { gsap } from 'gsap'
import Splitting from "splitting"

import { getStyle } from '../Utils/style-utils.js'

export default class UiBloc {
    constructor() {
        this.uiBloc = document.querySelector('.ui-bloc')
        this.experience = new Experience()
        this.resources = this.experience.resources
        this.holderBarElement = document.querySelector('.loading-holder')
        Splitting()

        /**
         * Buttons
         */
        this.chromeCheckBox = document.querySelector('#color-1')
        this.roseGoldCheckBox = document.querySelector('#color-2')
        this.blackCheckBox = document.querySelector('#color-3')

        this.btnRecycle = document.querySelector('#recycle')
        this.btnLoadAll = document.querySelector('#load-3')
        this.btnTop = document.querySelector('#load-2-top')
        this.btnBottom = document.querySelector('#load-2-bottom')
        this.question = document.querySelector('#question')

        this.recycleBloc = document.querySelector('.recycle-button-container')
        this.softBloc = document.querySelector('.soft-button-container')
        this.hardBloc = document.querySelector('.hard-button-container')
        this.normalBloc = document.querySelector('.normal-button-container')

        this.chromeName = document.getElementById("chrome-name")
        this.roseGoldName = document.getElementById("rose-gold-name")
        this.blackName = document.getElementById("black-name")

        this.switch1 = document.querySelector('[id=switch-1]')
        this.switch2 = document.querySelector('[id=switch-2]')
        this.switchTheme = document.querySelector('[data-theme-toggle]')

        // this.InfoBloc = document.querySelector('.info')


        window.setTimeout(() => {
            this.holderBarElement.classList.add('opening')
        }, 500)

        // Text animation
        this.DOM = {
            content: {
                loader: {
                    section: document.querySelector('.loader'),
                    get chars () {
                        return this.section.querySelectorAll('.app-name .word > .char')
                    },
                    isVisible: true
                },
                question: {
                    section: document.querySelector('.question'),
                    get words () {
                        return this.section.querySelectorAll('.text .word')
                    },
                    isVisible: false
                }
            }
        }

        this.timelineSettings = {
            staggerValue: 0.03,
            charsDuration: 0.2,
            wordsDuration: 0.8
        }

        this.timelineQuestion = gsap.timeline({ paused: true })
            .fromTo(this.DOM.content.question.words, { y: '-70%', opacity: 0 }, {
                duration: this.timelineSettings.wordsDuration,
                ease: 'power2.inOut',
                y: '0',
                opacity: 1,
                stagger: this.timelineSettings.staggerValue
            })

        this.timelineLoader = gsap.timeline({ paused: true })
            .fromTo(this.DOM.content.loader.chars, { y: '-50%', opacity: 0 }, {
                duration: this.timelineSettings.charsDuration,
                ease: 'power2.inOut',
                y: '0',
                opacity: 1,
                stagger: this.timelineSettings.staggerValue
            })

        this.switchLoader()

        this.resources.on('ready', () => {
            this.switchLoader()

        })
    }

    switchLoader () {
        this.timelineLoader[this.DOM.content.loader.isVisible ? 'play' : 'reverse']()
        this.DOM.content.loader.isVisible = !this.DOM.content.loader.isVisible
    }

    playRecycle () {
        this.btnRecycle.onclick = ""
        this.experience.world.playblade()
        this.btnRecycle.classList.add("-playing", "-loading")

        this.buttonHeight = this.recycleBloc.scrollHeight

        this.recycleBloc.style.height = this.buttonHeight + 'px'
        this.recycleBloc.classList.add("-playing-pos")

        //SET BEFORE SIZES
        this.sectionHeight = this.uiBloc.scrollHeight
        this.sectionWidth = this.uiBloc.scrollWidth
        this.padding = getStyle(this.uiBloc, 'padding')
        this.border = getStyle(this.uiBloc, 'border')
        this.uiBloc.style.height = this.sectionHeight + (this.border * 2) + 'px'
        this.uiBloc.style.width = this.sectionWidth + (this.border * 2) + 'px'

        window.setTimeout(() => {
            this.uiBloc.style.height = this.sectionHeight - (this.padding * 1.4) + 'px'
        }, 1)

        window.setTimeout(() => {
            this.btnRecycle.classList.add("-hide")
            this.btnRecycle.classList.add("-none")
            this.btnRecycle.onclick = function () { window.experience.world.uiBloc.playRecycle() }
            this.btnRecycle.classList.remove("-playing", "-loading")

            this.question.classList.remove("-none")
            this.btnLoadAll.parentElement.classList.remove("-none")
            this.btnTop.parentElement.classList.remove("-none")
            this.btnBottom.parentElement.classList.remove("-none")
        }, 9500)

        window.setTimeout(() => {
            // question + 3 buttons sizes
            this.newSectionHeight = this.experience.canvas.offsetHeight - this.softBloc.getBoundingClientRect().top + this.question.getBoundingClientRect().height
            this.newSectionWidth = this.btnBottom.parentElement.parentElement.scrollWidth + this.padding

            this.uiBloc.style.height = this.newSectionHeight - this.padding + (this.border * 2) + 'px'
            this.uiBloc.style.width = this.newSectionWidth + this.padding + (this.border * 2) + 'px'

            this.recycleBloc.style.height = 0 + 'px'
            this.recycleBloc.classList.add("-none")
            this.recycleBloc.classList.remove("-playing-pos")
        }, 9500)

        window.setTimeout(() => {
            this.question.classList.remove("-hide")
            this.timelineQuestion.play()
        }, 9800)

        window.setTimeout(() => {
            this.btnTop.parentElement.classList.remove("-hide")
        }, 10300)
        window.setTimeout(() => {
            this.btnBottom.parentElement.classList.remove("-hide")
        }, 10400)
        window.setTimeout(() => {
            this.btnLoadAll.parentElement.classList.remove("-hide")
        }, 10500)
    }

    playLoadAll (event) {
        this.experience.world.loadall(event)
        this.btnTop.parentElement.classList.add("-hide")
        this.btnBottom.parentElement.classList.add("-hide")
        this.timelineQuestion.reverse()
        this.btnLoadAll.onclick = ""

        window.setTimeout(() => {
            this.question.classList.add("-hide")

            this.btnLoadAll.classList.add("-playing", "-loading")
            this.normalBloc.classList.add("-playing-pos")
        }, 500)

        window.setTimeout(() => {
            this.uiBloc.style.height = this.sectionHeight - (this.padding * 1.2) + (this.border * 2) + 'px'
            this.uiBloc.style.width = this.newSectionWidth + (this.border * 2) - (this.padding * 2.3) + 'px'
        }, 550)

        window.setTimeout(() => {
            this.btnTop.parentElement.classList.add("-none")
            this.btnBottom.parentElement.classList.add("-none")
            this.question.classList.add("-none")
        }, 600)

        window.setTimeout(() => {
            this.btnLoadAll.parentElement.classList.add("-hide")
            this.uiBloc.style.width = this.sectionWidth + (this.border * 2) + 'px'
            this.uiBloc.style.height = this.sectionHeight + (this.border * 2) + 'px'
        }, 9000)
        window.setTimeout(() => {
            this.btnLoadAll.parentElement.classList.add("-none")
            this.btnLoadAll.classList.remove("-playing", "-loading")
            this.normalBloc.classList.remove("-playing-pos")
            this.btnRecycle.classList.remove("-none")
            this.recycleBloc.classList.remove("-none")
            this.recycleBloc.style.height = this.buttonHeight + 'px'
        }, 9500)

        window.setTimeout(() => {
            this.btnRecycle.classList.remove("-hide")
            this.btnLoadAll.onclick = function () { window.experience.world.uiBloc.playLoadAll(event) }
        }, 9600)

    }
    playLoadTop (event) {
        this.btnTop.onclick = ""
        this.experience.world.loadtop(event)
        this.btnLoadAll.parentElement.classList.add("-hide")
        this.btnBottom.parentElement.classList.add("-hide")
        this.timelineQuestion.reverse()

        window.setTimeout(() => {
            this.uiBloc.style.height = this.sectionHeight - (this.padding * 0.8) + (this.border * 2) + 'px'
            this.uiBloc.style.width = this.newSectionWidth + (this.border * 2) + 'px'
        }, 450)

        window.setTimeout(() => {
            this.btnTop.classList.add("-playing", "-loading")

            this.softBloc.classList.add("-playing-pos")

            this.btnLoadAll.parentElement.classList.add("-none")
            this.btnBottom.parentElement.classList.add("-none")
            this.question.classList.add("-none")
        }, 500)

        window.setTimeout(() => {
            this.btnTop.parentElement.classList.add("-hide")
        }, 7600)

        window.setTimeout(() => {
            this.uiBloc.style.width = this.sectionWidth + (this.border * 2) + 'px'
            this.uiBloc.style.height = this.sectionHeight + (this.border * 2) + 'px'
        }, 7900)

        window.setTimeout(() => {
            this.btnTop.parentElement.classList.add("-none")
            this.btnTop.onclick = function () { window.experience.world.uiBloc.playLoadTop(event) }
            this.btnTop.classList.remove("-playing", "-loading")
            this.softBloc.classList.remove("-playing-pos")
            this.btnRecycle.classList.remove("-none")
            this.recycleBloc.style.height = this.buttonHeight + 'px'
        }, 8200)

        window.setTimeout(() => {
            this.btnRecycle.classList.remove("-hide")
        }, 8300)
    }
    playLoadBottom (event) {
        this.btnBottom.onclick = ""
        this.experience.world.loadbottom(event)

        this.btnLoadAll.parentElement.classList.add("-hide")
        this.btnTop.parentElement.classList.add("-hide")
        this.timelineQuestion.reverse()

        window.setTimeout(() => {
            this.uiBloc.style.height = this.sectionHeight - (this.padding * 0.8) + (this.border * 2) + 'px'
            this.uiBloc.style.width = this.newSectionWidth + (this.padding / 2) + (this.border * 2) + 'px'
        }, 450)

        window.setTimeout(() => {
            this.btnBottom.classList.add("-playing", "-loading")

            this.hardBloc.classList.add("-playing-pos")

            this.btnLoadAll.parentElement.classList.add("-none")
            this.btnTop.parentElement.classList.add("-none")
            this.question.classList.add("-none")
        }, 500)

        window.setTimeout(() => {
            this.btnBottom.parentElement.classList.add("-hide")
        }, 7600)

        window.setTimeout(() => {
            this.uiBloc.style.width = this.sectionWidth + (this.border * 2) + 'px'
            this.uiBloc.style.height = this.sectionHeight + (this.border * 2) + 'px'
        }, 7900)

        window.setTimeout(() => {
            this.btnBottom.parentElement.classList.add("-none")
            this.btnBottom.onclick = function () { window.experience.world.uiBloc.playLoadBottom(event) }
            this.btnBottom.classList.remove("-playing", "-loading")
            this.hardBloc.classList.remove("-playing-pos")
            this.btnRecycle.classList.remove("-none")
            this.recycleBloc.style.height = this.buttonHeight + 'px'
        }, 8200)

        window.setTimeout(() => {
            this.btnRecycle.classList.remove("-hide")
        }, 8300)
    }

    update () {
    }
}